"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.manual_lot_status = void 0;
var api_1 = require("../../../api");
var manual_lot_status = function (req) {
    return (0, api_1.apiPut)({
        endpoint: "v3/lot/manual_lot_status",
        // data: formData,
        data: req,
    });
};
exports.manual_lot_status = manual_lot_status;
